import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-static-screen',
  standalone: true,
  imports: [CommonModule],
  template: `
    <h2>{{ screenLabel }}</h2>
    <p>You have landed on the {{ screenLabel }} screen.</p>
  `
})
export class StaticScreenComponent implements OnInit, OnDestroy {
  screenLabel = 'Dashboard';
  private sub!: Subscription;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.sub = this.route.paramMap.subscribe(pm => {
      const key = (pm.get('name') ?? 'DASHBOARD');
      try {
        const map = JSON.parse(sessionStorage.getItem('SCREENS') || '{}') as Record<string, string>;
        this.screenLabel = map?.[key] ?? key;
      } catch {
        this.screenLabel = key;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}


